import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Personal } from './components/Personal';
import { Experience } from './components/Experience';
import { Skills } from './components/Skills';
import { Values } from './components/Values';
import { Contact } from './components/Contact';
import { BackToTop } from './components/BackToTop';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-amber selection:text-cream" data-id="element-0" data-mp="2rk426rxr2eb7">
      <div data-id="element-1" data-mp="2mmcd05ohp6ap">
        <main data-id="element-2" data-mp="2mmlvz9b4ad6w">
          <Hero data-id="element-3" data-mp="2mn5a0exnchfn" />
          <Story data-id="element-4" data-mp="2mnnfm2678808" />
          <Personal data-id="element-5" data-mp="2mjznn7gejtnm" />
          <Experience data-id="element-6" data-mp="31agput0v2nlk" />
          <Skills data-id="element-7" data-mp="31bs1ff0jszn8" />
          <Values data-id="element-8" data-mp="31c9ts0k3atpv" />
          <Contact data-id="element-9" data-mp="31ctflscv2296" />
        </main>

        <footer className="py-8 text-center text-charcoal/40 text-sm font-light border-t border-amber/10" data-id="element-10" data-mp="2wjgrdjc3fxgy">
          <p data-id="element-11" data-mp="28tmfb3zlmcxr">© {new Date().getFullYear()} Jacob Palkin. Crafted with care.</p>
        </footer>

        <BackToTop data-id="element-12" data-mp="23vupcfiil0w7" />
      </div>
    </div>;
}